import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { versions } from 'src/environments/versions';

import { AuthService } from './services/auth.service';
import { AuthTracing } from './utilities/auth-tracing.utils';

// eslint-disable-next-line frontend-rules/ngx-translate-service
export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private route: ActivatedRoute) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(InterceptorSkipHeader)) {
      const headers = req.headers.delete(InterceptorSkipHeader);
      return next.handle(req.clone({ headers }));
    }
    return this.authService.getToken().pipe(
      mergeMap((token) => {
        if (
          !token &&
          (req.url.includes('/tutor/questions/') ||
            req.url.includes('/tutor/notes/') ||
            req.url.includes('/tutor/feature_flags') ||
            req.url.includes('/tutor/auth') ||
            req.url.includes('/tutor/code') ||
            req.url.includes('/tutorcruncher/company-login') ||
            req.url.includes('/teams/session') ||
            req.url.includes('/zoom/session') ||
            req.url.includes('/spaces/public-details') ||
            /\/spaces\/recordings\/[^/]+\/view/.test(req.url) ||
            /\/spaces\/recordings\/[^/]+\/transcript/.test(req.url) ||
            /\/analytics\/sessions\/[^/]+\/details/.test(req.url))
        ) {
          req = req.clone({
            setHeaders: {
              'Content-Type': 'application/json; charset=utf-8',
              Accept: 'application/json',
            },
          });
        } else if (token) {
          req = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
        } else {
          // Don't set fbUser to null for legitimate public requests (i18n files)
          if (!req.url.includes('assets/i18n')) {
            AuthTracing.log('AuthInterceptor.no_token_for_protected_request', { url: req.url });
            this.authService.fbUser.next(null);
            return EMPTY;
          }
        }

        /* Append the client version to the header for every request */
        if (versions.version) {
          req = req.clone({
            setHeaders: {
              'Release-Version':
                this.route.snapshot.queryParamMap.get('version') ?? versions.version,
            },
          });
        }

        return next.handle(req);
      }),
    );
  }
}
